import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  type SimpleChanges,
  Renderer2,
  Optional,
  HostBinding
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInput]',
  standalone: false
})
export class InputDirective implements OnInit, OnChanges {
  @Input() appInput: '' | 'default' = 'default';
  @Input() noIcon = false;
  @Input() border = false;
  @Input() hasError = false;
  @Input() ignoreDirtyTouched = false;

  private previousClasses: string[] = [];

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Optional() private ngControl: NgControl
  ) {}

  @HostBinding('attr.aria-invalid')
  get isAriaInvalid(): string | null {
    if (this.hasError) {
      return 'true';
    }
    if (this.ignoreDirtyTouched) {
      return null;
    }
    if (this.ngControl) {
      return this.ngControl.invalid && (this.ngControl.dirty || this.ngControl.touched)
        ? 'true'
        : null;
    }
    const el = this.el.nativeElement;
    return el.classList.contains('ng-invalid') &&
      (el.classList.contains('ng-dirty') || el.classList.contains('ng-touched'))
      ? 'true'
      : null;
  }

  ngOnInit(): void {
    this.updateClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appInput'] || changes['noIcon'] || changes['border'] || changes['hasError']) {
      this.updateClasses();
    }
  }

  private updateClasses(): void {
    // Remove previous classes
    this.previousClasses.forEach((cls) => {
      this.renderer.removeClass(this.el.nativeElement, cls);
    });

    // Calculate new classes
    const classes = this.getClasses();

    // Add new classes
    classes.forEach((cls) => {
      this.renderer.addClass(this.el.nativeElement, cls);
    });

    // Store for next update
    this.previousClasses = classes;
  }

  private getClasses(): string[] {
    const classes: string[] = ['input-box'];

    if (this.noIcon) {
      classes.push('input-box--no-icon');
    }

    if (this.border) {
      classes.push('input-box--border');
    }

    if (this.hasError) {
      classes.push('error-box');
    }

    return classes;
  }
}
